<!-- src/views/SettingsView.html -->
<div class="view-container">
  <div class="header-section" style="display: flex; justify-content: space-between; align-items: center;">
    
    <div class="header-content">
      <h1 class="view-title">Impostazioni</h1>
      <p class="view-desc">Configurazione gateway e regole operative.</p>
    </div>

    <div class="header-actions">
      <button class="theme-toggle-btn rounded-soft shadow-soft" @click="toggleTheme">
        <component :is="themeStore.darkMode ? 'Sun' : 'Moon'" :size="20" />
        <span>{{ themeStore.darkMode ? 'Chiaro' : 'Scuro' }}</span>
      </button>
    </div>
    
  </div>

  <div class="tabs-nav border-bottom">
    <button class="tab-btn" :class="{active: activeTab === 'gateway'}" @click="activeTab = 'gateway'">
      <CreditCard :size="18" /> Gateway
    </button>
    <button class="tab-btn" :class="{active: activeTab === 'rules'}" @click="activeTab = 'rules'">
      <Settings :size="18" /> Regole Prenotazione
    </button>
    <button class="tab-btn" :class="{active: activeTab === 'system'}" @click="activeTab = 'system'">
      <Sun :size="18" /> Settaggi di Sistema
    </button>
  </div>

  <div class="main-grid">
    <!--
    <div v-if="activeTab === 'gateway'">
      <div class="stripe-panel">
        <div class="panel-header"><h3>Stato Connessione Gateway STRIPE</h3></div>
        <div class="panel-body">
          <div class="status-indicator">
            <span class="dot" :class="stripeConnected ? 'dot-green' : 'dot-red'"></span>
            <span class="status-text">
              {{ stripeConnected ? 'Gateway attivo e configurato' : 'Gateway non configurato o offline' }}
            </span>
          </div>
        </div>
      </div>

      <div class="stripe-panel" style="margin-top: 1.5rem;">
      <div class="panel-header"><h3>Storico Transazioni</h3></div>
        <div class="filters-bar" style="display: flex; gap: 10px; padding: 1rem; border-bottom: 1px solid var(--color-border);">
          <input type="date" v-model="filters.dateFrom" class="filter-input" placeholder="Dal">
          <input type="date" v-model="filters.dateTo" class="filter-input" placeholder="Al">
          <select v-model="filters.status" class="filter-input">
            <option value="">Tutti gli stati</option>
            <option value="success">Ok</option>
            <option value="failed">Fallita</option>
          </select>
        </div>
        <div class="panel-body">
          <table class="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Data</th>
                <th>Importo</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="txn in paginatedTransactions" :key="txn.id">
                <td>{{ txn.id }}</td>
                <td>{{ txn.date }}</td>
                <td>{{ formatCurrency(txn.amount) }}</td>
                <td>
                  <span class="status-badge" :class="'txn-' + txn.status">
                    {{ txn.status === 'success' ? 'Ok' : 'Fallita' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
      
          <div class="pagination-controls">
            <button 
              :disabled="currentPage === 1" 
              @click="changePage(currentPage - 1)">
              Precedente
            </button>
            
            <span class="pagination-info">Pagina {{ currentPage }} di {{ totalPages }}</span>
            
            <button 
              :disabled="currentPage === totalPages" 
              @click="changePage(currentPage + 1)">
              Successiva
            </button>
          </div>
        </div>
      </div>
    </div>
    -->
    <div v-if="activeTab === 'gateway'">
  
      <!-- Griglia Gateway -->
      <div class="gateway-grid">
        
        <div 
          v-for="gw in gateways" 
          :key="gw.key" 
          class="stripe-panel gateway-card"
          :class="{ 'gateway-active': settings[gw.enabledKey] }"
        >
          <div class="panel-header" style="display: flex; justify-content: space-between; align-items: center;">
            <h3 style="margin: 0;">{{ gw.label }}</h3>
            <label class="switch">
              <input type="checkbox" v-model="settings[gw.enabledKey]">
              <span class="slider"></span>
            </label>
          </div>
          
          <div class="panel-body">
            <div class="status-indicator">
              <span class="dot" :class="settings[gw.enabledKey] ? 'dot-green' : 'dot-red'"></span>
              <span class="status-text">
                {{ settings[gw.enabledKey] ? 'Attivo' : 'Disabilitato' }}
              </span>
            </div>
            
            <!-- Metodi supportati -->
            <div class="gateway-methods" style="margin-top: 0.75rem;">
              <span 
                v-for="method in gw.methods" 
                :key="method" 
                class="method-tag"
              >
                {{ method }}
              </span>
            </div>

            <!-- Nota informativa per wallet -->
            <p v-if="gw.note" class="gateway-note" style="margin-top: 0.75rem; font-size: 0.8rem; opacity: 0.7;">
              ℹ️ {{ gw.note }}
            </p>
          </div>
        </div>

      </div>

      <!-- Storico Transazioni (invariato) -->
      <div class="stripe-panel" style="margin-top: 1.5rem;">
        <div class="panel-header"><h3>Storico Transazioni</h3></div>
        <div class="filters-bar" style="display: flex; gap: 10px; padding: 1rem; border-bottom: 1px solid var(--color-border);">
          <input type="date" v-model="filters.dateFrom" class="filter-input" placeholder="Dal">
          <input type="date" v-model="filters.dateTo" class="filter-input" placeholder="Al">
          <select v-model="filters.status" class="filter-input">
            <option value="">Tutti gli stati</option>
            <option value="success">Ok</option>
            <option value="failed">Fallita</option>
          </select>
        </div>
        <div class="panel-body">
          <table class="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Data</th>
                <th>Importo</th>
                <th>Gateway</th>
                <th>Stato</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="txn in paginatedTransactions" :key="txn.id">
                <td>{{ txn.id }}</td>
                <td>{{ txn.date }}</td>
                <td>{{ formatCurrency(txn.amount) }}</td>
                <td>{{ txn.gateway || '-' }}</td>
                <td>
                  <span class="status-badge" :class="'txn-' + txn.status">
                    {{ txn.status === 'success' ? 'Ok' : 'Fallita' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        
          <div class="pagination-controls">
            <button :disabled="currentPage === 1" @click="changePage(currentPage - 1)">Precedente</button>
            <span class="pagination-info">Pagina {{ currentPage }} di {{ totalPages }}</span>
            <button :disabled="currentPage === totalPages" @click="changePage(currentPage + 1)">Successiva</button>
          </div>
        </div>
      </div>

      <!-- Bottone Salva Gateway -->
      <div class="form-actions" style="margin-top: 20px; text-align: right;">
        <button @click="saveGatewaySettings" class="btn-save">Salva Configurazione Gateway</button>
      </div>

    </div>

    
    <div v-if="activeTab === 'rules'">
      <div class="stripe-panel">
        <div class="panel-header"><h3>Wallet & Prenotazioni</h3></div>
        <div class="panel-body">
          <div class="toggle-row">
            <span>Abilita Wallet</span>
            <label class="switch">
              <input type="checkbox" v-model="settings.walletEnabled">
              <span class="slider"></span>
            </label>            
          </div>
          <div v-if="settings.walletEnabled" class="config-sub-fields" style="margin-top: 1rem;">
            <label>Importo minimo ricaricabile:</label>
            <input type="number" v-model="settings.min_recharge_amount" placeholder="Es: 10.00">

            <div class="toggle-row">
              <span>Segnalare basso importo wallet</span>
              <label class="switch"><input type="checkbox" v-model="settings.notify_low_wallet_balance"><span class="slider"></span></label>
            </div>
            <div v-if="settings.notify_low_wallet_balance" class="toggle-row">
              <label>Importo minimo (Soglia):</label>
              <input type="number" v-model="settings.low_wallet_threshold" placeholder="Es: 5.00">
            </div>
          </div>
          <label>Prenotazioni</label>
          <div class="radio-group" style="margin-top: 1.5rem;">
            <button :class="{'active': settings.bookingType === 'free'}" @click="settings.bookingType = 'free'">Libere</button>
            <button :class="{'active': settings.bookingType === 'deposit'}" @click="settings.bookingType = 'deposit'">Richiesto Acconto</button>
            <button :class="{'active': settings.bookingType === 'full'}" @click="settings.bookingType = 'full'">Richiesto Saldo</button>
          </div>
          
          <div v-if="settings.bookingType === 'deposit'" class="form-group" style="margin-top: 1rem;">
            <label style="display:block; margin-bottom: 0.5rem;">Valore Acconto</label>
            <div class="input-group-compact">
              <input type="number" v-model="settings.depositValue" placeholder="Importo...">
              <select v-model="settings.depositType">
                <option value="%">%</option>
                <option value="fix">€</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="stripe-panel" style="margin-top: 1.5rem;">
        <div class="panel-header"><h3>Politiche di Modifica</h3></div>
        <div class="panel-body">
          <div class="toggle-row"><span>Annullabile</span><label class="switch"><input type="checkbox" v-model="settings.cancellable"><span class="slider"></span></label></div>
          <div v-if="settings.cancellable" class="config-sub-fields">
            <input type="number" v-model="settings.cancelHours" placeholder="Ore anticipo">
            <div class="toggle-row"><span>Rimborsabile</span><label class="switch"><input type="checkbox" v-model="settings.refundable"><span class="slider"></span></label></div>
          </div>
          <div class="toggle-row" style="margin-top: 1rem;"><span>Rinviabile</span><label class="switch"><input type="checkbox" v-model="settings.reschedulable"><span class="slider"></span></label></div>
          <div v-if="settings.reschedulable" class="config-sub-fields">
            <input type="number" v-model="settings.rescheduleHours" placeholder="Ore anticipo">
          </div>
        </div>        
      </div>

      <div class="form-actions" style="margin-top: 20px; text-align: right;">
        <button @click="saveSettings" class="btn-save">
          Salva Modifiche
        </button>
      </div>
    </div>

    <div v-if="activeTab === 'system'">
      <div class="stripe-panel">
        <div class="panel-header"><h3>Notifiche e Reminder</h3></div>
        <div class="panel-body">
          <div class="toggle-row">
            <span>Invia Promemoria</span>
            <label class="switch"><input type="checkbox" v-model="settings.send_appointment_reminder"><span class="slider"></span></label>
          </div>
          <div v-if="settings.send_appointment_reminder" class="form-group">
            <label>Ore prima del reminder:</label>
            <input type="number" v-model="settings.reminder_hours_before">
          </div>
          
          <hr>
          
          <div class="toggle-row">
            <span>Notifica Conferma Prenotazione</span>
            <label class="switch"><input type="checkbox" v-model="settings.notify_booking_confirmed"><span class="slider"></span></label>
          </div>
          <div class="toggle-row">
            <span>Notifica Spostamento</span>
            <label class="switch"><input type="checkbox" v-model="settings.notify_rescheduled"><span class="slider"></span></label>
          </div>
        </div>
      </div>
      
      <div class="form-actions" style="margin-top: 20px; text-align: right;">
        <button @click="saveSettings" class="btn-save">Salva Modifiche</button>
      </div>
    </div>
  </div>
</div>